import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';

import { iamRevokeRefreshToken } from '@crossnokaye/typescript-sdk/funcs/iamRevokeRefreshToken';
import {
  RevokeRefreshTokenRequest,
  RevokeRefreshTokenResponse,
} from '@crossnokaye/typescript-sdk/models/operations';

import { atlasClient } from '@/clients/atlas';

export type RevokeRefreshTokenOptions = Omit<
  UseMutationOptions<RevokeRefreshTokenResponse, Error, RevokeRefreshTokenRequest>,
  'mutationFn'
>;

export type RevokeUserRefreshTokenResult = UseMutationResult<
  RevokeRefreshTokenResponse,
  Error,
  RevokeRefreshTokenRequest
>;

export function useRevokeRefreshToken(
  options?: RevokeRefreshTokenOptions
): RevokeUserRefreshTokenResult {
  return useMutation<RevokeRefreshTokenResponse, Error, RevokeRefreshTokenRequest>({
    mutationFn: async (request: RevokeRefreshTokenRequest) =>
      atlasClient<RevokeRefreshTokenRequest, RevokeRefreshTokenResponse>({
        atlasFunc: iamRevokeRefreshToken,
        request,
      }),
    ...options,
  });
}
